/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Select from 'components/commons/select'

import { DuplicateNFTsSelector, DuplicateNFTsTypes } from 'store';
import { chainOptions } from 'constant'

const DuplicateNFTsFilter = () => {

    const { activeChain } = useSelector(DuplicateNFTsSelector)

    const dispatch = useDispatch()

    const onChange = (e: any) => {
        dispatch({
            type: DuplicateNFTsTypes.SET_DUPLICATE_NFTS_ACTIVE_CHAIN,
            payload: e.target.value
        })
    }

    return (
        <div className='flex flex-col lg:flex-row md:justify-between items-center px-6 space-x-2 space-y-4 lg:space-y-0'>
            <div className='flex flex-row items-center space-x-2'>
                <p className='text-md font-500'>Select Chain: </p>
                <Select
                    {...{ onChange }}
                    defaultValue={activeChain}
                    options={chainOptions}
                />
            </div>
        </div>
    );
};

export default DuplicateNFTsFilter;